import { lazy } from 'react'

export const FeelHungryV1 = lazy(() => import('./FeelHungryV1'))
